export const METADATA_URL = `${process.env.NEXT_PUBLIC_METADATA_URL}`;
export const METADATA_API = `${process.env.NEXT_PUBLIC_METADATA_API}`;
